<template>
  <div>
    <el-form size="small">
      <el-row :gutter="15">
        <el-col :span="12">
          <DateForm
            ref="dateForm"
          />
        </el-col>
        <el-col :span="12">
          <el-form-item label="Customer">
            <AccountAutoComplete
              ref="accountList"
              v-model="account"
              placeholder="All Customers"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="15">
        <el-col :span="8">
          <el-form-item>
            <el-checkbox
              v-model="reportType"
              label="Report Detail"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col>
        <el-button
          type="primary"
          size="small"
          class="float-right"
          @click.native="downloadCSV()"
        >
          Generate Report
        </el-button>
      </el-col>
    </el-row>
    <Preview
      v-if="isShowPreview"
      title="Invoice Summary Report"
      :is-show.sync="isShowPreview"
      :is-direct-download="true"
      :configuration="configuration"
    />
  </div>
</template>

<script>
import DateForm from '@/components/Application/Reports/DateForm'
import AccountAutoComplete from '@/components/Application/Reports/AccountAutoComplete'
import Preview from '@/components/Application/Reports/Preview'

export default {
  components: {
    DateForm,
    AccountAutoComplete,
    Preview
  },
  data () {
    return {
      breadcrumb: {
        name: 'Invoice Summary',
        route: { name: 'reports-invoice-summary' }
      },
      account: {},
      form: {
        accountId: null,
        dateFrom: null,
        dateTo: null,
        invoiceStatus: null
      },
      formTem: null,
      reportType: false,
      isShowPreview: false,
      configuration: null
    }
  },
  methods: {
    setDate (date) {
      this.form.dateFrom = this.$moment(date[0]).format('YYYY-MM-DD HH:mm:ss')
      this.form.dateTo = this.$moment(date[1]).format('YYYY-MM-DD HH:mm:ss')
    },
    downloadCSV () {
      this.$refs.dateForm.$refs.form.validate(async valid => {
        if (valid) {
          this.setDate(this.$refs.dateForm.form.value)

          if (this.$refs.accountList.getAccountIds()) {
            this.form.accountId = this.$refs.accountList.getAccountIds()
          } else {
            this.form.accountId = null
          }
          this.formTem = this.form

          this.clean(this.formTem)

          let _pathname = 'InvoiceSummary'
          if (this.reportType) {
            _pathname = 'InvoiceSummaryDetail'
          }

          this.configuration = {
            report: _pathname,
            params: this.form
          }
          this.isShowPreview = true
        }
      })
    },
    clean (obj) {
      var propNames = Object.getOwnPropertyNames(obj)
      for (var i = 0; i < propNames.length; i++) {
        var propName = propNames[i]
        if (obj[propName] === null || obj[propName] === undefined) {
          delete obj[propName]
        }
      }
    }
  }
}
</script>

<style>

</style>
